import { client } from "../../../api/client";
import {CommandDispatcher} from "../domain/CommandDispatcher"

export class SyncAPICommandDispatcher implements CommandDispatcher{
  dispatch(cmd_name,args): Promise<{[key: string]: any} > {
    let command_args = args
    command_args['cmd_name'] = cmd_name
    let p = new Promise<{[key: string]: any}>(function(resolve, reject){
      client
      .post(`sync_command_bus/`,{command:command_args}).
      then(response => resolve(response.data)).
      catch(e => reject(e))
    })
    return p
  }
}